import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  baseProfile: "tiny",
  version: "1.2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18 11H6a2 2 0 0 0 0 4h12a2 2 0 0 0 0-4" }, null, -1)
  ])))
}
export default { render: render }